import { render, staticRenderFns } from "./SellingPointWithText.vue?vue&type=template&id=f680a184&scoped=true&"
import script from "./SellingPointWithText.vue?vue&type=script&lang=js&"
export * from "./SellingPointWithText.vue?vue&type=script&lang=js&"
import style0 from "./SellingPointWithText.vue?vue&type=style&index=0&id=f680a184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f680a184",
  null
  
)

export default component.exports